import { Form, Input, Space } from 'antd';
import type { NamePath } from 'antd/es/form/interface';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import type { MetersByMeterModelsFilter } from 'lib/services';
import { omit } from 'ramda';
import type { FC } from 'react';
import { DEFAULT_FILTER, useMetersByModelIdWithPagination } from '../hooks/useMetersFilterWithPagination';
import { InventoryLocationSelect } from '@/components/form/select/InventoryLocationSelect';

const selectStyle = { minWidth: 200, width: 250 };

export const MetersFilter: FC = () => {
  const [form] = Form.useForm<MetersByMeterModelsFilter>();

  const { filter, setPaginationState, resetFilterState, setFilterAndPaginationState } =
    useMetersByModelIdWithPagination();

  const handleReset = () => {
    form.setFieldsValue(omit(['sort'], DEFAULT_FILTER));
    resetFilterState();
    setPaginationState({ current: 1 });
  };

  return (
    <Form
      form={form}
      initialValues={filter}
      layout="inline"
      onFinish={(values: MetersByMeterModelsFilter) => setFilterAndPaginationState(values, { current: 1 })}
    >
      <Space wrap orientation="vertical">
        <Space wrap align="center" orientation="horizontal">
          <Form.Item
            label="Tools ID"
            name={'toolsIds' satisfies NamePath<MetersByMeterModelsFilter>}
            tooltip="Search by Tools ID"
          >
            <Input allowClear placeholder="Tools ID..." style={selectStyle} />
          </Form.Item>
          <Form.Item
            label="Search"
            name={'search' satisfies NamePath<MetersByMeterModelsFilter>}
            tooltip="Search by Name, Code, or Serial number"
          >
            <Input allowClear placeholder="Search..." style={selectStyle} />
          </Form.Item>

          <Form.Item label="Inventory Location" name={'locations' satisfies NamePath<MetersByMeterModelsFilter>}>
            <InventoryLocationSelect mode="multiple" maxTagCount="responsive" style={selectStyle} />
          </Form.Item>
          <FilterControlButtons onClickReset={handleReset} />
        </Space>
      </Space>
    </Form>
  );
};
